(function() {
  'use strict';

  function initFormationNavigation() {
    const root = document.querySelector('.dlf-formation');
    if (!root) return null;

    const live = root.querySelector('.live');
    const labelEl = root.querySelector('.current_video_label');
    if (!live || !labelEl) return null;

    const prevBtn = root.querySelector('[data-nav="prev"]');
    const nextBtn = root.querySelector('[data-nav="next"]');

    const medias = [];
    Array.from(root.querySelectorAll('.module')).forEach((modEl) => {
      modEl.querySelectorAll('.video-title[data-video-for]').forEach(tEl => {
        const cont = tEl.closest('.video');
        medias.push({
          type: 'video',
          titleEl: tEl,
          playEl: cont ? cont.querySelector('.play') : null,
          titleText: tEl.textContent.trim(),
          tplId: 'video-tpl-' + tEl.dataset.videoFor
        });
      });

      modEl.querySelectorAll('.audio-title[data-audio-for]').forEach(tEl => {
        const cont = tEl.closest('.audio');
        medias.push({
          type: 'audio',
          titleEl: tEl,
          playEl: cont ? cont.querySelector('.play') : null,
          titleText: tEl.textContent.trim(),
          tplId: 'audio-tpl-' + tEl.dataset.audioFor
        });
      });
    });

    let currentIndex = 0;
    const muxDurationCache = new Map();

    function updateNavButtons() {
      const atStart = currentIndex <= 0;
      const atEnd = currentIndex >= medias.length - 1;
      if (prevBtn) { prevBtn.disabled = atStart; prevBtn.setAttribute('aria-disabled', String(atStart)); }
      if (nextBtn) { nextBtn.disabled = atEnd; nextBtn.setAttribute('aria-disabled', String(atEnd)); }
    }

    function injectTemplateById(tplId) {
      const tpl = root.querySelector('#' + tplId);
      if (!tpl) return false;

      live.innerHTML = tpl.innerHTML;

      /* VIMEO (désactivé, remplacé par Mux Player) :
      live.querySelectorAll('iframe[src*="player.vimeo.com"]').forEach(ifr => {
        try {
          const url = new URL(ifr.getAttribute('src'), location.origin);
          if (url.searchParams.get('autoplay') === '1') {
            url.searchParams.set('autoplay', '0');
            ifr.setAttribute('src', url.toString());
          }
        } catch(_) {}
      });
      */

      const muxEl = live.querySelector('mux-player');
      if (muxEl) {
        const playbackId = muxEl.getAttribute('playback-id');
        muxEl.addEventListener('loadedmetadata', () => {
          const d = muxEl.duration;
          if (!d || isNaN(d)) return;
          const slot = findVideoTimeSlot(tpl);
          if (slot && (!slot.textContent.trim() || slot.textContent.trim() === '--:--')) {
            slot.textContent = formatDuration(d);
          }
          if (playbackId) muxDurationCache.set(playbackId, Promise.resolve(d));
        }, { once: true });
      }

      const audioEl = live.querySelector('audio[data-audio-src]');
      if (audioEl) {
        const audioIndex = tplId.replace('audio-tpl-', '');
        audioEl.addEventListener('loadedmetadata', function() {
          const duration = this.duration;
          if (duration && !isNaN(duration)) {
            const timeSlot = root.querySelector(`.audio-title[data-audio-for="${audioIndex}"]`)?.closest('.audio-block')?.querySelector('time[data-audio-duration]');
            if (timeSlot) {
              timeSlot.textContent = formatDuration(duration);
            }
          }
        });
        audioEl.load();
      }

      return true;
    }

    function loadByIndex(index, opts = {}) {
      const item = medias[index];
      if (!item) return;

      if (!injectTemplateById(item.tplId)) return;

      labelEl.textContent = item.titleText;

      root.querySelectorAll('.video-title.is_active, .audio-title.is_active')
        .forEach(el => el.classList.remove('is_active'));
      item.titleEl.classList.add('is_active');

      root.querySelectorAll('.video-block.selected, .audio-block.selected')
        .forEach(el => el.classList.remove('selected'));
      if (item.type === 'video') {
        const videoBlock = item.titleEl.closest('.video')?.querySelector('.video-block');
        if (videoBlock) videoBlock.classList.add('selected');
      } else if (item.type === 'audio') {
        const audioBlock = item.titleEl.closest('.audio')?.querySelector('.audio-block');
        if (audioBlock) audioBlock.classList.add('selected');
      }

      if (!opts.noScroll && root) {
        const headerOffset = 100;
        const elementPosition = root.getBoundingClientRect().top + window.pageYOffset;
        const offsetPosition = elementPosition - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth'
        });
      }

      const autoplay = !!opts.autoplay;
      if (autoplay) {
        if (item.type === 'audio') {
          const audioEl = live.querySelector('audio');
          if (audioEl) audioEl.play().catch(() => {});
        } else if (item.type === 'video') {
          const muxEl = live.querySelector('mux-player');
          if (muxEl) {
            const playMux = () => { try { const p = muxEl.play(); if (p && p.catch) p.catch(() => {}); } catch(_) {} };
            if (window.customElements) customElements.whenDefined('mux-player').then(playMux);
          }
          /* VIMEO (désactivé, remplacé par Mux Player) :
          const iframe = live.querySelector('iframe[src*="player.vimeo.com"]');
          if (iframe) {
            try {
              if (window.Vimeo && window.Vimeo.Player) {
                new Vimeo.Player(iframe).play().catch(() => {});
              }
            } catch(_) {}
            let src = iframe.getAttribute('src') || '';
            if (!/[?&]autoplay=1/.test(src)) {
              iframe.setAttribute('src', src + (src.includes('?') ? '&' : '?') + 'autoplay=1');
            }
          }
          */
        }
      }

      currentIndex = index;
      updateNavButtons();
    }

    function goNext(e) {
      if (e) e.preventDefault();
      if (currentIndex < medias.length - 1) loadByIndex(currentIndex + 1, { noScroll: true });
    }
    function goPrev(e) {
      if (e) e.preventDefault();
      if (currentIndex > 0) loadByIndex(currentIndex - 1, { noScroll: true });
    }

    medias.forEach((item, idx) => {
      const el = item.titleEl;
      const activate = () => loadByIndex(idx);
      el.style.cursor = 'pointer';
      el.setAttribute('role', 'button');
      el.setAttribute('tabindex', '0');
      el.addEventListener('click', activate);
      el.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
      });
    });

    medias.forEach((item, idx) => {
      const pl = item.playEl;
      if (!pl) return;
      const trigger = () => loadByIndex(idx);
      pl.style.cursor = 'pointer';
      pl.setAttribute('role', 'button');
      pl.setAttribute('tabindex', '0');
      pl.addEventListener('click', trigger);
      pl.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); trigger(); }
      });
    });

    medias.forEach((item, idx) => {
      const videoContainer = item.titleEl.closest('.video') || item.titleEl.closest('.audio');
      if (!videoContainer) return;
      const activate = () => loadByIndex(idx);
      videoContainer.style.cursor = 'pointer';
      videoContainer.setAttribute('role', 'button');
      videoContainer.setAttribute('tabindex', '0');
      videoContainer.addEventListener('click', (e) => {
        if (e.target === item.titleEl || e.target === item.playEl || e.target.closest('.play') || e.target.closest('.video-title') || e.target.closest('.audio-title')) {
          return;
        }
        activate();
      });
      videoContainer.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); activate(); }
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', goPrev);
    if (nextBtn) nextBtn.addEventListener('click', goNext);

    if (medias.length) loadByIndex(0);

    /* ---------------- Durées vidéo et audio ---------------- */

    function formatDuration(totalSeconds) {
      if (totalSeconds == null || isNaN(totalSeconds)) return '--:--';
      const s = Math.floor(totalSeconds % 60);
      const m = Math.floor((totalSeconds / 60) % 60);
      const h = Math.floor(totalSeconds / 3600);
      const pad = n => String(n).padStart(2, '0');
      return h > 0 ? `${h}:${pad(m)}:${pad(s)}` : `${m}:${pad(s)}`;
    }

    /* ---------- Durées vidéo ---------- */

    function findVideoTimeSlot(tpl) {
      const container = tpl.closest('.video') || tpl.parentElement;
      if (!container) return null;
      return container.querySelector('.video-duration time')
        || container.querySelector('.video-block time')
        || container.querySelector('time');
    }

    /* ---------- Mux durations ---------- */

    function getMuxPlaybackIdFromTemplate(tpl) {
      if (tpl.content) {
        const el = tpl.content.querySelector('mux-player[playback-id]');
        if (el) return el.getAttribute('playback-id');
      }
      const m = (tpl.innerHTML || '').match(/playback-id="([^"]+)"/i);
      return m ? m[1] : null;
    }

    // Durée lue dans le manifeste HLS public : master .m3u8 -> 1re rendition -> somme des #EXTINF
    function getMuxDuration(playbackId) {
      if (muxDurationCache.has(playbackId)) return muxDurationCache.get(playbackId);

      const p = (async () => {
        try {
          const masterUrl = 'https://stream.mux.com/' + encodeURIComponent(playbackId) + '.m3u8';
          const master = await fetch(masterUrl).then(r => r.ok ? r.text() : Promise.reject());
          const variant = master.split('\n').map(l => l.trim()).find(l => l && !l.startsWith('#'));
          if (!variant) return null;
          const media = await fetch(new URL(variant, masterUrl)).then(r => r.ok ? r.text() : Promise.reject());
          let total = 0;
          media.replace(/#EXTINF:([\d.]+)/g, (_, d) => { total += parseFloat(d); return _; });
          return total > 0 ? total : null;
        } catch (_) {
          return null;
        }
      })();

      muxDurationCache.set(playbackId, p);
      return p;
    }

    async function populateVideoDurations() {
      const templates = Array.from(root.querySelectorAll('template[id^="video-tpl-"]'));
      if (!templates.length) return;

      // 4 requêtes en parallèle max
      let next = 0;
      async function worker() {
        while (next < templates.length) {
          const tpl = templates[next++];
          const slot = findVideoTimeSlot(tpl);
          if (!slot) continue;

          const playbackId = getMuxPlaybackIdFromTemplate(tpl);
          if (!playbackId) { slot.textContent = '--:--'; continue; }

          const seconds = await getMuxDuration(playbackId);
          slot.textContent = formatDuration(seconds);
        }
      }
      await Promise.all([worker(), worker(), worker(), worker()]);
    }

    /* VIMEO (désactivé, remplacé par Mux Player) :
    function getVimeoIframeSrcFromTemplate(tpl) {
      if (tpl.content) {
        const ifr = tpl.content.querySelector('iframe[src*="player.vimeo.com"]');
        if (ifr) return ifr.getAttribute('src') || ifr.getAttribute('data-src');
      }
      const html = tpl.innerHTML || '';
      const m = html.match(/<iframe[^>]+src="([^"]*player\.vimeo\.com[^"]+)"/i)
            || html.match(/data-src="([^"]*player\.vimeo\.com[^"]+)"/i);
      return m ? m[1] : null;
    }

    function ensureVimeoPlayerSDK() {
      if (window.Vimeo && window.Vimeo.Player) return Promise.resolve();

      return new Promise((resolve, reject) => {
        const existing = document.querySelector('script[src="https://player.vimeo.com/api/player.js"]');
        if (existing) {
          existing.addEventListener('load', () => resolve(), { once: true });
          existing.addEventListener('error', reject, { once: true });
          return;
        }
        const s = document.createElement('script');
        s.src = 'https://player.vimeo.com/api/player.js';
        s.async = true;
        s.onload = () => resolve();
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }

    let vimeoProbe = null;
    function getVimeoProbe() {
      if (vimeoProbe) return vimeoProbe;

      const probe = document.createElement('div');
      probe.style.position = 'absolute';
      probe.style.left = '-99999px';
      probe.style.top = '0';
      probe.style.width = '1px';
      probe.style.height = '1px';
      probe.style.overflow = 'hidden';
      document.body.appendChild(probe);

      vimeoProbe = probe;
      return probe;
    }

    function normalizeVimeoSrc(src) {
      try {
        const url = new URL(src, location.origin);
        if (!url.searchParams.has('autoplay')) url.searchParams.set('autoplay', '0');
        return url.toString();
      } catch (_) {
        return src;
      }
    }

    function getVimeoDurationFromEmbedSrc(src, cache) {
      const key = normalizeVimeoSrc(src);
      if (cache.has(key)) return cache.get(key);

      const p = (async () => {
        await ensureVimeoPlayerSDK();

        return new Promise(resolve => {
          const probe = getVimeoProbe();

          const iframe = document.createElement('iframe');
          iframe.src = key;
          iframe.setAttribute('allow', 'autoplay; fullscreen');
          iframe.setAttribute('allowfullscreen', '');
          iframe.setAttribute('frameborder', '0');
          iframe.style.width = '1px';
          iframe.style.height = '1px';

          probe.appendChild(iframe);

          let done = false;
          const finish = (sec) => {
            if (done) return;
            done = true;
            try { iframe.remove(); } catch(_) {}
            resolve(sec);
          };

          try {
            const player = new window.Vimeo.Player(iframe);
            player.getDuration()
              .then(sec => finish(isFinite(sec) ? sec : null))
              .catch(() => finish(null));

            setTimeout(() => finish(null), 6000);
          } catch (_) {
            finish(null);
          }
        });
      })();

      cache.set(key, p);
      return p;
    }

    async function populateVideoDurations() {
      const templates = root.querySelectorAll('template[id^="video-tpl-"]');
      if (!templates.length) return;

      const cache = new Map();

      for (const tpl of templates) {
        const slot = findVideoTimeSlot(tpl);
        if (!slot) continue;

        const src = getVimeoIframeSrcFromTemplate(tpl);
        if (!src) { slot.textContent = '--:--'; continue; }

        const seconds = await getVimeoDurationFromEmbedSrc(src, cache);
        slot.textContent = formatDuration(seconds);
      }
    }
    */

    /* ---------- Audio durations ---------- */

    function getAudioSrcFromTemplate(tpl) {
      if (tpl.content) {
        const a = tpl.content.querySelector('audio');
        if (a) {
          return a.getAttribute('src') || a.getAttribute('data-audio-src');
        }
      }
      const html = tpl.innerHTML || '';
      const m1 = html.match(/data-audio-src="([^"]+)"/i);
      if (m1 && m1[1]) return m1[1];
      const m2 = html.match(/<audio[^>]*\s+src="([^"]+)"/i);
      return m2 ? m2[1] : null;
    }

    async function populateAudioDurations() {
      const templates = root.querySelectorAll('template[id^="audio-tpl-"]');
      if (!templates.length) return;

      const probe = document.createElement('div');
      probe.style.position = 'absolute';
      probe.style.left = '-99999px';
      probe.style.top = '0';
      probe.style.width = '1px';
      probe.style.height = '1px';
      probe.style.overflow = 'hidden';
      document.body.appendChild(probe);

      const cache = new Map();

      for (const tpl of templates) {
        const container = tpl.closest('.audio') || tpl.parentElement;
        if (!container) continue;
        const audioIndex = tpl.id.replace('audio-tpl-', '');
        const timeEl = container.querySelector('time[data-audio-duration]')
          || root.querySelector(`.audio-title[data-audio-for="${audioIndex}"]`)?.closest('.audio-block')?.querySelector('time[data-audio-duration]');
        if (!timeEl) continue;

        const src = getAudioSrcFromTemplate(tpl);
        if (!src) { timeEl.textContent = '--:--'; continue; }

        if (!cache.has(src)) {
          cache.set(src, new Promise(resolve => {
            const a = document.createElement('audio');
            a.preload = 'metadata';
            a.src = src;
            a.muted = true;
            a.style.width = '1px';
            a.style.height = '1px';
            probe.appendChild(a);

            const done = sec => { resolve(sec); a.remove(); };
            a.addEventListener('loadedmetadata', () => {
              const d = isFinite(a.duration) ? a.duration : null;
              done(d);
            }, { once: true });
            a.addEventListener('error', () => done(null), { once: true });
          }));
        }

        const seconds = await cache.get(src);
        timeEl.textContent = formatDuration(seconds);
      }

      probe.remove();
    }

    /* ---------- Bind sur iframes injectées ---------- */

    /* VIMEO (désactivé, remplacé par Mux Player) :

    function attachPlayerWhenIframeAppears(scope = document) {
      if (!(window.Vimeo && window.Vimeo.Player)) return;

      const iframes = scope.querySelectorAll('iframe[src*="player.vimeo.com"]');
      iframes.forEach(iframe => {
        if (iframe.hasAttribute('data-duration-bound')) return;
        iframe.setAttribute('data-duration-bound', '1');

        try {
          const player = new window.Vimeo.Player(iframe);
          player.getDuration().then(seconds => {
            const container = iframe.closest('.video') || iframe.parentElement;
            const slot = container && (
              container.querySelector('.video-duration time')
              || container.querySelector('.video-block time')
              || container.querySelector('time')
            );
            if (slot && !slot.textContent.trim()) slot.textContent = formatDuration(seconds);
          }).catch(() => {});
        } catch (_) {}
      });
    }

    const mo = new MutationObserver(muts => {
      muts.forEach(m => {
        if (m.type === 'childList' && m.addedNodes) {
          m.addedNodes.forEach(node => {
            if (node.nodeType === 1) {
              if (node.tagName === 'IFRAME') {
                attachPlayerWhenIframeAppears(node.parentElement || node);
              } else {
                attachPlayerWhenIframeAppears(node);
              }
            }
          });
        }
      });
    });

    function initDurations() {
      populateVideoDurations();
      populateAudioDurations();

      ensureVimeoPlayerSDK().then(() => {
        attachPlayerWhenIframeAppears(document);
        mo.observe(document.documentElement, { childList: true, subtree: true });
      }).catch(() => {});
    }
    */

    function initDurations() {
      populateVideoDurations();
      populateAudioDurations();
    }

    initDurations();

    return {
      medias: medias,
      currentIndex: () => currentIndex,
      setCurrentIndex: (idx) => { currentIndex = idx; },
      reload: initFormationNavigation
    };
  }

  /* ---------------- Sommaire latéral des modules ---------------- */

  function initModuleToc() {
    const toc = document.querySelector('[data-formation-toc]');
    if (!toc) return;

    const list = toc.querySelector('ol');
    const links = Array.from(toc.querySelectorAll('[data-toc-link]'));
    const items = links
      .map(link => ({ link, target: document.getElementById(link.getAttribute('href').slice(1)) }))
      .filter(item => item.target);
    if (!items.length) return;

    const docStyle = document.documentElement.style;
    const mobileQuery = window.matchMedia('(max-width: 1199px)');

    // Hauteurs du header collant (et de la barre du sommaire sur mobile) pour caler le scroll
    function updateOffsets() {
      const header = document.querySelector('.section-header');
      docStyle.setProperty('--dlf-header-h', (header ? header.offsetHeight : 0) + 'px');
      docStyle.setProperty('--dlf-toc-h', (mobileQuery.matches ? toc.offsetHeight : 0) + 'px');
    }

    let activeLink = null;
    function setActive(link) {
      if (link === activeLink) return;
      if (activeLink) {
        activeLink.classList.remove('is-active');
        activeLink.removeAttribute('aria-current');
      }
      activeLink = link;
      if (!link) return;
      link.classList.add('is-active');
      link.setAttribute('aria-current', 'true');
      // Sur mobile, garder la pastille active visible dans la barre horizontale
      if (mobileQuery.matches && list) {
        list.scrollTo({ left: link.parentElement.offsetLeft - 16, behavior: 'smooth' });
      }
    }

    // Module actif = dernier module dont le haut est passé sous le header
    function updateActive() {
      const offset = parseFloat(getComputedStyle(items[0].target).scrollMarginTop) || 100;
      let current = null;
      for (const item of items) {
        if (item.target.getBoundingClientRect().top - offset <= 40) current = item;
        else break;
      }
      setActive(current ? current.link : null);
    }

    let ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => { ticking = false; updateActive(); });
    }

    items.forEach(({ link, target }) => {
      link.addEventListener('click', e => {
        e.preventDefault();
        updateOffsets();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + target.id);
        setActive(link);
      });
    });

    updateOffsets();
    updateActive();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', () => { updateOffsets(); updateActive(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initModuleToc);
  } else {
    initModuleToc();
  }

  let navigationInstance = null;

  function startNavigation() {
    if (navigationInstance) return;
    navigationInstance = initFormationNavigation();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startNavigation);
  } else {
    startNavigation();
  }

})();